import { render } from "./ProfilePanel.vue?vue&type=template&id=cb3aa736&scoped=true&ts=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=ts"
export * from "./ProfilePanel.vue?vue&type=script&lang=ts"

import "./ProfilePanel.vue?vue&type=style&index=0&id=cb3aa736&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3aa736"]])

export default __exports__